import { Component, OnInit } from '@angular/core';
import { Location } from "@angular/common";
import { Router } from "@angular/router";

@Component({
  selector: "app-card-request-physical-card",
  templateUrl: "./card-request-physical-card.component.html",
  standalone:false,
  styleUrls: ["./card-request-physical-card.component.scss"],
})
export class CardRequestPhysicalCardComponent implements OnInit {
  CardRequestNameAppear;
  constructor(private router: Router, private location: Location) {}

  ngOnInit(): void {}

  cardRequestNameAppear() {
    this.router.navigateByUrl("/CardRequestNameAppear");
  }
  payCardSuccess() {
    this.router.navigateByUrl("/PayCardSuccess");
  }
}
